const ROOT = 'StepConfirm/sectionConfirm/processConfirm';

export const FETCH_PROCESS_CONFIRM_REQUEST = `${ROOT}/FETCH_PROCESS_CONFIRM_REQUEST`;
export const FETCH_PROCESS_CONFIRM_SUCCESS = `${ROOT}/FETCH_PROCESS_CONFIRM_SUCCESS`;
export const FETCH_PROCESS_CONFIRM_FAILURE = `${ROOT}/FETCH_PROCESS_CONFIRM_FAILURE`;

export const CLEAR_PROCESS_CONFIRM_DATA = `${ROOT}/CLEAR_PROCESS_DATA`;
